import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

// Stat Card (10602:914; the child page's tiles on 10764:83360): a small icon and caption over
// one number. Figma's sub-line under the number is on the 047 Later list.
const StatCard = ({ Icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      px: "16px",
      py: "14px",
      minWidth: 0,
      bgcolor: tokens.surface.default,
      border: `1px solid ${tokens.border.subtle}`,
      borderRadius: "12px",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0, color: tokens.text.tertiary }}>
      {Icon && <Icon size={14} />}
      <Typography variant="labelCaption" component="div" noWrap>
        {label}
      </Typography>
    </Box>
    <Typography variant="titleMetric" sx={{ color: tokens.text.primary }}>
      {value}
    </Typography>
  </Box>
);

export default StatCard;
